import ReactDOM from "react-dom/client";

import { ToastContainer } from "react-toastify";
import malinchexInit from "./services/malinchex";
import "react-toastify/dist/ReactToastify.css";

import "./index.css";
import App from "./App";
import { LOCALES } from "./utils/constants";

const root = ReactDOM.createRoot(document.getElementById("root"));

const params = new URLSearchParams(window.location.search);
const countryParam = (params.get("country") || "").trim().toLowerCase();
const country = countryParam in LOCALES ? countryParam : "mx";
const locale = LOCALES[country];

malinchexInit(locale).then(() => root.render(
  <>
    <ToastContainer
      toastClassName={() =>
        "relative flex py-4 px-3 rounded overflow-hidden cursor-pointer bg-white shadow-lg"
      }
      bodyClassName={() => "text-black text-base font-normal"}
      position="bottom-left"
      autoClose={4000}
      hideProgressBar={true}
      newestOnTop={false}
      closeButton={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      style={{ zIndex: 11000 }}
    />
    <App locale={locale} />
  </>
))
